export default __webpack_public_path__ + "static/media/image1.9e949218.png";